(() => {
  const root = document.querySelector('[data-kabo-welcome]');
  if (!root) return;

  const modal = root.querySelector('[data-kabo-welcome-modal]');
  if (!modal) return;

  const openers = root.querySelectorAll('[data-kabo-welcome-open]');
  const closers = root.querySelectorAll('[data-kabo-welcome-close]');
  const emailInput = root.querySelector('[data-kabo-welcome-email]');
  const successPanel = root.querySelector('[data-kabo-welcome-success-panel]');
  let lastFocused = null;

  const getFocusable = () => Array.from(
    modal.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')
  ).filter((element) => !element.hidden && element.offsetParent !== null);

  const openModal = () => {
    lastFocused = document.activeElement;
    modal.hidden = false;
    openers.forEach((button) => button.setAttribute('aria-expanded', 'true'));
    document.body.classList.add('kabo-welcome-modal-open');

    requestAnimationFrame(() => {
      const focusTarget = emailInput || modal.querySelector('[data-kabo-welcome-close]');
      if (focusTarget) focusTarget.focus();
    });
  };

  const closeModal = () => {
    modal.hidden = true;
    openers.forEach((button) => button.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('kabo-welcome-modal-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  openers.forEach((button) => button.addEventListener('click', openModal));
  closers.forEach((button) => button.addEventListener('click', closeModal));

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;

    if (event.key === 'Escape') {
      closeModal();
      return;
    }

    if (event.key !== 'Tab') return;

    const focusable = getFocusable();
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  if (successPanel) openModal();
})();
